<app-marketers *ngIf="plateform" [plateform]="plateform"></app-marketers>